import { LoginEndpoint } from '@core/endpoints/login.endpoint';
import { LoginService } from '@core/framework/login.service';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { BaseState, LoginParams, BaseResponse } from '@base/entities/BaseEntities';
import { Component, ViewChild } from '@angular/core';
import { EnumLanguages, EnumLoginExtensionLinkType, EnumLoginSecureKeyTypes, EnumNotificationDeliveryOptions } from '@core/framework/sysenums.enum';
import { SysGlobals } from '@core/framework/sysglobals';
import { Observable, Subscription } from 'rxjs';
import { EnumSystemOptions } from '@core/framework/systemoptions.enum';
import { Utils } from '@core/helpers/Utils';
import { DxValidationGroupComponent } from 'devextreme-angular';
import { LoginExtensionLink } from '@base/classes/BaseClasses';
import { LanguageService } from '@m4u-angular/core/framework/language.service';
import { SessionService } from '@m4u-angular/core/framework/session.service';

class State extends BaseState {
    //IsMultiLanguage: boolean;
    IsSupportedLoginByPassword: boolean;
    IsSaveCredentials: boolean;
    IsRequireTaxNumberForOTP: boolean;
    ShowPasswordRecoveryLink: boolean;
    LoginExtensionLinks$: Observable<LoginExtensionLink[]>;
    ReturnUrl: string;
    ReturnUrlParams: string;
    Stage: number;
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-login-by-otp',
    templateUrl: './login-by-otp.component.html',
    styleUrls: ['./login-by-otp.component.scss']
})
export class LoginByOtpComponent extends BasePageComponent<LoginParams, State>
{
    @ViewChild('validationGroup') protected validationGroup: DxValidationGroupComponent;

    private _subscriptions: Subscription[] = [];

    constructor(A: ServiceBagService,
        private loginService: LoginService,
        private loginEndpoint: LoginEndpoint,
        private languageService: LanguageService) {
        super(A, 'LoginByOtpComponent', LoginParams, State);
    }

    override OnInitComponent() {
        if (this.SystemOptionFlag(EnumSystemOptions.IsSupportedLoginByOTP) == false) {
            this.Navigate(["/system/login"], { Language: SysGlobals.Language });
            return;
        }

        this.State.ShowPasswordRecoveryLink = this.SystemOptionFlag(EnumSystemOptions.IsSupportedPasswordRecovery);
        this.State.IsSupportedLoginByPassword = this.SystemOptionFlag(EnumSystemOptions.IsSupportedLoginByPassword);
        this.State.IsRequireTaxNumberForOTP = this.SystemOptionFlag(EnumSystemOptions.IsRequireTaxNumberForOTP);
        this.Entity.DeliveryOption = EnumNotificationDeliveryOptions.Email;
        this.State.ReturnUrl = this.QueryParams.ReturnUrl && (this.QueryParams.ReturnUrl as string).replace(this.A.AppConfigService.M4UConfig.deploymentApplicationFolder, '');
        this.State.ReturnUrlParams = this.QueryParams.ReturnUrlParams;
        this.State.Stage = 1;

        this.LoadExtension();

        this._subscriptions.push(this.languageService.Language$.subscribe(language => {
            if (this.Entity.Language === language) return;
            
            this.Entity.Language = language;

            this.A.Navigator.Navigate(["/system/login-otp"], { Language: SysGlobals.Language });
            setTimeout(() => this.A.Navigator.ReloadApplication(), 500);
        }));
    }

    override OnInitEntity() {
        //Take default language from URL to allow presetting it
        //this.State.IsMultiLanguage = this.A.AppConfigService.M4UConfig.isMultiLanguage;
        if (this.QueryParams.Language != undefined) {
            this.Entity.Language = (this.QueryParams.Language == EnumLanguages.English ? EnumLanguages.English : EnumLanguages.Hebrew);
        }
        else {
            this.Entity.Language = this.A.AppConfigService.M4UConfig.defaultLanguage;
        }
        this.languageService.SetLanguage(this.Entity.Language);

        //Take sure if was passed in
        this.Entity.UserName = this.QueryParams.UserName;
    }

    OnExtensionLinkClick(link: LoginExtensionLink) {
        if (link.Type === EnumLoginExtensionLinkType.Route) this.Navigate([link.Link]);
    }

    OnPasswordRecovery() {
        this.Navigate(['/system/passwordrecovery'], { UserName: this.Entity.UserName })
    }

    override OnSubmitPage() {
        if (this.State.Stage == 1) this.OnSendOtp();
        else if (this.State.Stage == 2) this.OnLogin();
    }

    // Send otp
    OnSendOtp() {
        if (!this.validationGroup.instance.validate().isValid) return;
        this.Do(this.loginEndpoint.SendOtp(this.Entity), false, (response: BaseResponse) => {
            if (response.IsSuccess) {
                this.UI.InfoMessage(this.RC('msgNotificationSent'));
                this.State.Stage = 2
            } else {
                this.UI.StopMessage(response.ResponseMessage);
            }
        });
    }

    // Perform the login
    OnLogin() {
        if (!this.validationGroup.instance.validate().isValid) return;
        this.Entity.SecureKeyType = EnumLoginSecureKeyTypes.Otp;
        this.loginService.DoLogin(this.Entity, false, this.State.IsSaveCredentials, () => { this.OnAfterInit(); })
            .subscribe(() => {});
    }

    OnResend() {
        this.State.Stage = 1;
    }

    GoToLogin() {
        if (this.State.IsSupportedLoginByPassword) this.Navigate(['/system/login']);
    }

    private LoadExtension() {
        this.State.LoginExtensionLinks$ = this.A.AppConfigService.AppConfig.OnGetAppLoginExtensionLinks();
    }

    private OnAfterInit() {
        if (!!this.State.ReturnUrl) {
            var params = this.State.ReturnUrlParams ? JSON.parse(this.State.ReturnUrlParams) : undefined;
            this.A.Navigator.Navigate([this.State.ReturnUrl], params);
            return;
        }
        this.A.Framework.NavigateDefault();
    }

    GetAppTitle() {
        const moduleName = this.GetFirstModuleName();
        return this.A.ResourcesService.RC('$$AppTitles.LoginAppName', moduleName);
    }

    GetAppCompanyName() {
        const moduleName = this.GetFirstModuleName();
        return this.A.ResourcesService.RC('$$AppTitles.LoginCompanyName', moduleName);
    }

    protected override OnDestroyComponent(): void {
        this._subscriptions.forEach(x => x.unsubscribe());
    }
}
